import { PALETTE } from '../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";

export default MediaQueryStyleSheet.create({
  root:
  {
    flexDirection: 'column',
    flex: '1',
    backgroundColor: PALETTE.duskBlue,
    padding: 18,
    marginBottom: 15
  },
  rootCustom:
  {
    flexDirection: 'column',
    flex: '1',
    backgroundColor:PALETTE.morningBlue,
    padding: 18,
    marginBottom: 15
  },
  headerRoot: {
    flexDirection: 'column',
    flex: '1',
    padding: 18,
    // display: 'flex'
  },
  container: {
    flexDirection: 'row',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  titlePadding: {
    paddingLeft: 10,
  },
  searchRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 24,
    marginLeft: 10,
  },
  searchWrapper: {
    width: 432,
    marginRight: 16,
  },
  daysWrapper: {
    width: 220,
    flexDirection: 'row',
  },
  loadingData: {
  height:'100vh'
  },
  firstContainer: {
    // flexDirection: 'row',
    // flex:2,
    display: 'flex',
    // justifyContent: 'space-between'
    },
  listItemFirst: {
    width: '20%',
    display: 'flex',
    justifyContent: "space-between",
    alignItems: 'flex-start',
  },
  listItemTransStart: {
    justifyContent: "flex-start",
    alignItems: 'flex-start',
    flex: 1,
    flexDirection: 'row',
  },
  listItemStart: {
    // justifyContent: "flex-start",
    // alignItems: 'flex-start',
    // flex: 0.5,
    // marginRight: '100px',
    // flexDirection: 'row',
    display: 'flex'
  },
  listItemReference: {
    justifyContent: "space-between",
    alignItems: 'flex-end',
    flex: 0.5,
    color: PALETTE.warning,
  },
  listItemStartNext: {
    justifyContent: "space-between",
    alignItems: 'flex-start',
    flex: 0.5,
  },
  listItem: {
    justifyContent: "space-between",
    alignItems: 'flex-end',
    flex: 1,
    color: PALETTE.warning,
  },
  listItemLast: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
  date: {
    color: PALETTE.secondaryActive,
    fontSize: 14,
  },
  negativeDate: {
    color: PALETTE.primaryNegative,
    fontSize: 14,
  },

  futureDate: {
    color: PALETTE.warning,
    fontSize:14,
  },

  textPopover: {
  color: PALETTE.darkBlue, 
  fontSize:12
  },

  currencyStyle: {
    fontSize: 16,
  },
  calendarContainer: {
    // border: "solid",
    //  borderWidth: "1px",
      // borderRadius: "3px",
     borderColor: PALETTE.primaryText,
    margin: "20px 20px 15px 15px", width: '300px', float: 'right'
  },
  decimalStyle: {
    fontSize: 12,
    color: PALETTE.secondaryActive
  },
  
  negativeDecimalStyle: {
    fontSize: 12,
    color: PALETTE.primaryNegative,
  },

  marketValueText: {
    color: PALETTE.secondaryActive,
    fontSize: '2.68vw',
    letterSpacing: 0.29,
  },
  
  currencyStyleHeader: {
    fontSize: 14,
    color: PALETTE.secondaryActive
  },

  curBalLabel:{
    marginRight:3, 
    paddingRight:2,
   
  },
  
  curBalDiv:{
    display:'flex',
     flexDirection:'row',
    },
   
    curBalDivPopover:{
      display:'flex', 
      flexDirection:'row',
       marginLeft:'10px'
    },

  transValueDateContainer:{
    display: 'flex', 
    flexDirection: 'row',
    width: '28%'
  },

  transDate:{
    width: '50%'
  },
  valueDate:{
    width:'50%'
  },
  description:{
    width:'17%'
  },
  reference:{
    width:'14%'
  },
  debit:{
    width:'12%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  credit:{
    width:'25%', 
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  balance:{
    width:'27%', 
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  }
  ,
  rootClear: {
    clear: 'both',
    marginLeft: 7,
    marginRight: 17,
  },
  scrollViewCustom: {
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: '500px',
    minHeight: '410px',
  }
});
